import { API, STORAGE_API } from '@/utils/api/api';

export const defaultLoggerApi = async ({ type, logInfo }) => {
  return await API.post(`default/LogError`, { type, logInfo });
};

// Dated-horizon bundle for the authenticated screen: several days of pre-resolved slots +
// deduped playlists, server time and an expiry. The player plays across days offline and
// rolls over locally.
export const getScheduleBundleApi = async () => {
  return await API.get('schedule/bundle');
};

export const getPlayerContentApi = async ({ file }) => {
  return await STORAGE_API.get(`contents/${file}`);
};

// Tenant branding/config (logo, custom idle placeholders) for the paired player.
export const getSettingsApi = async () => {
  return await API.get('/settings');
};

export const updateScreenMetaApi = async (data) => {
  return await API.put('/Screen/metadata', data);
};

// Server time in Unix ms: video wall tiles sample it to share one clock.
export const getServerTimeApi = async () => {
  return await API.get('Screen/time');
};

// Ably token request for this screen (clientId + capability are decided by the server).
export const getRealtimeTokenApi = async () => {
  return await API.post('realtime/auth');
};
